import { Routes, Route, Navigate } from "react-router-dom";
import Register from "./routes/Register";
import Verify from "./routes/Verify";
import AdminLogin from "./routes/admin/Login";
import AdminLayout from "./routes/admin/Layout";
import AdminContacts from "./routes/admin/Contacts";
import AdminLists from "./routes/admin/Lists";
import AdminMessages from "./routes/admin/Messages";
import AdminNewMessage from "./routes/admin/NewMessage";
import AdminMessageDetail from "./routes/admin/MessageDetail";

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/register" replace />} />
      <Route path="/register" element={<Register />} />
      <Route path="/verify" element={<Verify />} />

      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<Navigate to="contacts" replace />} />
        <Route path="contacts" element={<AdminContacts />} />
        <Route path="lists" element={<AdminLists />} />
        <Route path="messages" element={<AdminMessages />} />
        <Route path="messages/new" element={<AdminNewMessage />} />
        <Route path="messages/:id" element={<AdminMessageDetail />} />
      </Route>

      <Route path="*" element={<div className="container"><h1>404</h1></div>} />
    </Routes>
  );
}
